// extracted by mini-css-extract-plugin
module.exports = {"collapsableTextActions":"CollapsableText_collapsableTextActions__8C__P","collapsableTextArea":"CollapsableText_collapsableTextArea__L10i8"};